var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "form-group" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("input", {
      staticClass: "form-control margin-right-10",
      attrs: { type: "text", placeholder: "姓" },
      on: { change: _vm.changeFamilyNameKana }
    }),
    _vm._v(" "),
    _c("input", {
      staticClass: "form-control",
      attrs: { type: "text", placeholder: "名" },
      on: { change: _vm.changeFirstNameKana }
    })
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "item-name" }, [
      _c("label", { staticClass: "item" }, [_vm._v("フリガナ")]),
      _c("label", { staticClass: "required" }, [_vm._v("必須")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-68d504a8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-68d504a8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/molecules/InputKana.vue
// module id = null
// module chunks = 